import { Injectable } from "@angular/core";
import { AutomationRule } from "../interfaces/automation-rule.interface";
import { AutomationRuleDto } from "../interfaces/dto/automation-rule.dto";
import { WhatsappTemplateAdapter } from "./whatsapp-template.adapter";
import { MediaAdapter } from "./media.adapter";
import { AutomationEvent } from "../enums/automation-event.enum";
import { HttpMethod } from "../enums/http-method";

@Injectable({
  providedIn: 'root'
})
export class AutomationRuleAdapter {
  numberOfSends?: string;
  limitApplies?: string;
  timeWindow?: string;
  constructor(private templateAdapter: WhatsappTemplateAdapter, private mediaAdapter: MediaAdapter) {}

  run(rule: AutomationRuleDto): AutomationRule {
    return {
      ...rule,
      productFollowupConfig: rule.productFollowupConfig ? {
        ...rule.productFollowupConfig,
        templateId: rule.productFollowupConfig.templateId,
        template: rule.productFollowupConfig.template ? this.templateAdapter.run(rule.productFollowupConfig.template) : null,
        mediaId: rule.productFollowupConfig.mediaId ?? undefined,
        media: rule.productFollowupConfig.media ? this.mediaAdapter.run(rule.productFollowupConfig.media) : null,
        numberOfSends: rule.productFollowupConfig.numberOfSends ? rule.productFollowupConfig.numberOfSends : null,
        limitApplies: rule.productFollowupConfig.limitApplies ? rule.productFollowupConfig.limitApplies : null,
        timeWindow: rule.productFollowupConfig.timeWindow ? rule.productFollowupConfig.timeWindow : null
      } : undefined,
      rebookReminderConfig: rule.rebookReminderConfig ? {
        ...rule.rebookReminderConfig,
        templateId: rule.rebookReminderConfig.templateId,
        template: rule.rebookReminderConfig.template ? this.templateAdapter.run(rule.rebookReminderConfig.template) : null,
        mediaId: rule.rebookReminderConfig.mediaId ?? undefined,
        media: rule.rebookReminderConfig.media ? this.mediaAdapter.run(rule.rebookReminderConfig.media) : null,
      } : undefined,
      webhookConfig: rule.webhookConfig ? {
        ...rule.webhookConfig,
        eventType: AutomationEvent[rule.webhookConfig.eventType as keyof typeof AutomationEvent],
        url: rule.webhookConfig.url,
        method: HttpMethod[rule.webhookConfig.method as keyof typeof HttpMethod],
        headers: rule.webhookConfig.headers ? rule.webhookConfig.headers : undefined,
      } : undefined,
      preOpReminderConfig: rule.preOpReminderConfig ? {
        appointmentTypes: rule.preOpReminderConfig.appointmentTypes,
        clipboards: rule.preOpReminderConfig.clipboards,
        templateId: rule.preOpReminderConfig.templateId,
        template: rule.preOpReminderConfig.template ? this.templateAdapter.run(rule.preOpReminderConfig.template) : null,
        mediaId: rule.preOpReminderConfig.mediaId ?? undefined,
        media: rule.preOpReminderConfig.media ? this.mediaAdapter.run(rule.preOpReminderConfig.media) : null,
        delaysInDays: rule.preOpReminderConfig.delaysInDays,
      } : undefined,
      postOpReminderConfig: rule.postOpReminderConfig ? {
        appointmentTypes: rule.postOpReminderConfig.appointmentTypes,
        clipboards: rule.postOpReminderConfig.clipboards,
        templateId: rule.postOpReminderConfig.templateId,
        template: rule.postOpReminderConfig.template ? this.templateAdapter.run(rule.postOpReminderConfig.template) : null,
        mediaId: rule.postOpReminderConfig.mediaId ?? undefined,
        media: rule.postOpReminderConfig.media ? this.mediaAdapter.run(rule.postOpReminderConfig.media) : null,
        delaysInDays: rule.postOpReminderConfig.delaysInDays,
      } : undefined,
      paymentReminderConfig: rule.paymentReminderConfig ? {
        ...rule.paymentReminderConfig,
        templateId: rule.paymentReminderConfig.templateId,
        mediaId: rule.paymentReminderConfig.mediaId ?? undefined,
        media: rule.paymentReminderConfig.media ? this.mediaAdapter.run(rule.paymentReminderConfig.media) : null,
        template: rule.paymentReminderConfig.template ? this.templateAdapter.run(rule.paymentReminderConfig.template) : null,
      } : undefined
    };
  }
}
